import { ActionTypes } from 'modules/iterableGoals/ducks/actionTypes';
import { PerformantCampaignAction, PerformantCampaignState } from 'modules/iterableGoals/types';

export const initialPerformantCampaignState: PerformantCampaignState = {
  data: {
    best: [],
    worst: [],
  },
  loading: true,
  error: false,
};

export const performantCampaignReducer = (
  state = initialPerformantCampaignState,
  action?: PerformantCampaignAction,
) => {
  switch (action?.type) {
    case ActionTypes.FETCH_PERFORMANT_CAMPAIGNS_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };

    case ActionTypes.FETCH_PERFORMANT_CAMPAIGNS_RESPONSE:
      return {
        data: action?.payload,
        error: false,
        loading: false,
      };

    case ActionTypes.FETCH_PERFORMANT_CAMPAIGNS_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
      };

    default:
      return state;
  }
};
